export enum FilterComponentsEnum {
  RADIO_GROUP = 'radio_group', // select date range
  PURE_RADIO_GROUP = 'pure_radio_group', // just radio
  CHECK_BOX_GROUP = 'check_box_group',
  DATE_TIME_PICKER = 'date_time_picker',
  DROPDOWN = 'dropdown',
  INPUT = 'input',
  DATE_TIME_RANGE_PICKER = 'date_time_range_picker',
}
